// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".current-user[data-v-6b7e9c91]{align-items:center;display:flex;border-radius:50%;border:2px solid var(--white)}", "",{"version":3,"sources":["/app/app/javascript/dashboard/components/layout/sidebarComponents/AgentDetails.vue"],"names":[],"mappings":"AACA,+BACE,kBAAA,CACA,YAAA,CACA,iBAAA,CACA,6BAAA","file":"AgentDetails.vue","sourcesContent":["\n.current-user {\n  align-items: center;\n  display: flex;\n  border-radius: 50%;\n  border: 2px solid var(--white);\n}\n"]}]);
// Exports
module.exports = exports;
